module.exports = {"TXTWCL_Something_went_wrong":{"id":"TXTWCL_Something_went_wrong","defaultMessage":"Κάτι πήγε στραβά","track":"Something went wrong"}}